export default __webpack_public_path__ + "static/media/miscellaneous-mobile-bg.b2ffbcc0.webp";